import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CoreUserInfo } from './CoreUserInfo';

export class CoreUserInfoResource extends FBaseService {
  public async getCoreUserInfo(fiId: string, userId: number)
    : Promise<CoreUserInfo> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/core-user-info/${userId}`,
    );
    const results: CoreUserInfo = response.data.data;
    return results;
  }
}

export default CoreUserInfoResource;
